import { ResourceProps } from 'app/context/resource/types';

export const Resources: ResourceProps[] = [
  {
    name: 'admin/inspections',
    meta: {
      dataProviderName: 'micro'
    }
  },
  {
    name: 'inspections/:id/products',
    meta: {
      dataProviderName: 'micro'
    }
  },
  {
    name: 'inspections/:id/po-items',
    meta: {
      dataProviderName: 'micro'
    }
  },
  {
    name: 'inspections/po-items',
    meta: {
      dataProviderName: 'micro'
    }
  },
  {
    name: 'inspections/:id/progress',
    meta: {
      dataProviderName: 'micro'
    }
  },
  {
    name: '/admin/inspections/:id/report',
    meta: {
      dataProviderName: 'micro'
    }
  }
];
